import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "officeName", "city" ]

  handleSubmit(event) {
    event.preventDefault();

    const myForm = event.target;
    let officeName = this.officeNameTarget.value;
    let city = this.cityTarget.value;

    let confirmationMessage = `Thank you for submitting your sedation office request! We will contact ${officeName} in ${city} as soon as possible and reply to you via email with the result! Stay tuned!`;

    if (!officeName) {
      confirmationMessage = `Thank you for submitting your sedation office request! You will receive an email as soon as possible with recommendations based on your location and your needs. Stay tuned!`;
    }

    // Store the message in session storage or local storage item
    sessionStorage.setItem("confirmationMessage", confirmationMessage);

    const formData = new FormData(myForm);

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => {
        // On successful form submission, we redirect the user to a confirmation page
        window.location.href = "/patient/confirmation/";
      })
      .catch((error) => alert(error));
  }
}
